<script setup>
import { useAppStore } from '~/store/main'

// Store
const store = useAppStore()
const { theme } = storeToRefs(store)
const { setTheme } = store

// Cookies
const cookie = useCookie('theme', {
  maxAge: 0.5 * 24 * 60 * 60,
  path: '/',
})

if (!theme.value) {
  theme.value = cookie.value || 'dark'
}

const themeSwitcher = () => {
  const newTheme = theme.value === 'dark' ? 'light' : 'dark'
  setTheme(newTheme)
  cookie.value = newTheme
}
</script>

<template>
  <div
    class="theme text_minor_1"
    tabindex="0"
    role="button"
    @click="themeSwitcher"
    @keyup.enter="themeSwitcher"
  >
    <transition name="fade">
      <span v-show="theme === 'light'" class="theme__text theme__text--dark">
        Dark
      </span>
    </transition>
    <span class="circle" :class="{ 'circle--light': theme === 'light' }"></span>
    <transition name="fade">
      <span v-show="theme === 'dark'" class="theme__text theme__text--light">
        Light
      </span>
    </transition>
  </div>
</template>

<style lang="scss" scoped>
.circle {
  display: inline-block;
  width: 13px;
  height: 13px;
  background-color: $color-6;
  border-radius: 6.5px;
  transition: transform 0.5s ease;

  @include media-breakpoint-up(lg) {
    width: 16px;
    height: 16px;
    border-radius: 8px;
  }
  &--light {
    transform: translateX(41px);

    @include media-breakpoint-up(lg) {
      transform: translateX(46px);
    }
  }
}
.theme {
  position: relative;
  height: fit-content;
  border: 1px solid $color-6;
  border-radius: 15px;
  padding: 5px;
  color: $color-6;
  line-height: 0px;
  width: 66px;
  cursor: pointer;

  outline: none;
  &:focus-visible {
    outline: 2px dashed $color-root;
  }

  @include media-breakpoint-up(lg) {
    padding: 6px;
    width: 76px;
  }

  &:hover {
    border: 1px solid $color-7;
    color: $color-7;

    .circle {
      background-color: $color-7;
    }
  }

  &__text {
    position: absolute;
    top: 50%;
    transform: translateY(-50%);

    &--light {
      right: 10px;
    }
    &--dark {
      left: 10px;
    }
  }
}

.fade-leave-active {
  transition: all 0.1s ease;
}

.fade-enter-active {
  transition: all 0.7s ease;
}

.fade-enter-from,
.fade-leave-to {
  opacity: 0;
  height: 0px;
}
</style>
